import { render, staticRenderFns } from "./details.vue?vue&type=template&id=19fdb3a4"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=19fdb3a4&lang=less&scepod=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19fdb3a4')) {
      api.createRecord('19fdb3a4', component.options)
    } else {
      api.reload('19fdb3a4', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=19fdb3a4", function () {
      api.rerender('19fdb3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/details.vue"
export default component.exports